import { useEffect, useRef } from 'react';
import { useGameContext } from 'context/game.context';
import GAME_DEFAULTS from 'constants/GAME_DEFAULTS';
import _merge from 'lodash.merge';

export default function useGame(config = {}) {
  const parent = useRef();
  const { setGame } = useGameContext();

  useEffect(() => {
    if (parent.current) {
      const { width, height } = parent.current.getBoundingClientRect();
      const _game = new Phaser.Game({
        ..._merge({}, GAME_DEFAULTS, config),
        parent: parent.current,
        width,
        height,
      });
      setGame(_game);
      window.__game = _game;

      return () => _game.destroy();
    }
  }, []);

  return parent;
}
